// Here is where you can define configuration overrides based on the execution environment.
// Supply a key to the default export matching the NODE_ENV that you wish to target, and
// the base configuration will apply your overrides before exporting itself.
export const config = {
  // 172.24.14.115
  development: {
    // Used for 'npm run start'
    serverURL: "http://localhost:8080/payme",
  },
  production: {
    // Used for 'npm run build'
    // Production
    serverURL: "https://pay.future.com.kw/api",
    // Staging
    //serverURL: "http://testpay.future-club.com/api", 
  },
  test: {
    serverURL: "http://testpay.future-club.com/api",
  },
};
export default config[process.env.NODE_ENV];
export const BUILD_VERSION = "1.2.0";



// WEBPACK FOOTER //
// ./src/config/environment.js